import React from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import MediaQuery from "react-responsive"
import Loader from "react-loader-spinner"
import ChatIcon from "@mui/icons-material/Chat"
import Actions from "../../Redux/Actions"
import colors from "../../Constants/colors"
// import { Hamburger } from '../Icons/Hamburger';
import { BackArrow } from "../../Icons/BackArrow"
import PYPPartComponentMap from "../PYPPartMap/PYPPartMap"
import PYPFooter from "../PYPFooter/PYPFooter"
import PYPPartDesktopFooterContent from "../PYPPartDesktopFooterContent/PYPPartDesktopFooterContent"
import PYPPartMobileFooterContent from "../PYPPartMobileFooterContent/PYPPartPartMobileFooterContent"
import { FullCommitLogo } from "../../Icons/FullCommitLogo"
import CommitButtonWithoutClickState from "../CommitButtonWithoutClickState/CommitButtonWithoutClickState"
import { lightThemePartNames } from "./lightThemeParts"
import { gtmClickHandler } from "../../Utils/gtm"
import CoachesNotesModal from "../CoachesNotesModal/CoachesNotesModal"
import coachesNotesParts from "./coachesNotesParts"
import Tooltip from "../Tooltip/Tooltip"
import { isCourseBuilderWorkshop } from "../../Utils/workshopNavigation"

class PYPPartContainer extends React.Component {
  constructor(props) {
    super()
    this.lightThemePartNames = lightThemePartNames
    this.state = {
      modalOpen: false
    }
    this.clickChatIcon = this.clickChatIcon.bind(this)
  }


  componentDidMount() {
    console.log('[PYPPartContainer] componentDidMount', {
      pypIsInitialized: this.props.pypIsInitialized,
      initializedPart: this.props.initializedPart,
      currentModuleId: this.props.currentModuleId,
      currentModuleTitle: this.props.currentModuleTitle,
      hasModules: !!(this.props.modules && this.props.modules.byId),
      modulesCount: this.props.modules?.allIds?.length || 0,
      currentPartId: this.props.currentPartId,
      pathname: this.props.location.pathname
    })

    if (
      !this.props.unlockedUserModules.find((unlockedModule) => {
        return unlockedModule.module_id === this.props.currentModuleId
      })
    ) {
      // this.props.history.push('/workshop')
    }

    // Ensure PYP is initialized before trying to initialize part
    if (!this.props.pypIsInitialized) {
      console.log('[PYPPartContainer] PYP not initialized, waiting...')
      // Wait for PYP to initialize, then retry
      let retryCount = 0
      const maxRetries = 100 // 10 seconds max wait
      const checkInitialization = () => {
        retryCount++
        if (this.props.pypIsInitialized) {
          console.log('[PYPPartContainer] PYP initialized after', retryCount, 'retries')
          this.initializePartIfReady()
        } else if (retryCount < maxRetries) {
          setTimeout(checkInitialization, 100)
        } else {
          console.error('[PYPPartContainer] PYP failed to initialize after', maxRetries, 'retries')
        }
      }
      setTimeout(checkInitialization, 100)
    } else {
      this.initializePartIfReady()
    }
    
    document.title = `${this.props.currentPartTitle || ''} | ${this.props.currentModuleTitle || ''} | Pursue Your Purpose`
  }
  
  initializePartIfReady() {
    console.log('[PYPPartContainer] initializePartIfReady called', {
      pypIsInitialized: this.props.pypIsInitialized,
      hasModules: !!(this.props.modules && this.props.modules.byId),
      modulesCount: this.props.modules?.allIds?.length || 0,
      initializedPart: this.props.initializedPart,
      currentModuleId: this.props.currentModuleId
    })

    // initializePYPPart can derive module from URL, so we just need PYP to be initialized
    // and have modules loaded. It will handle module navigation internally if needed.
    if (this.props.pypIsInitialized && this.props.modules && this.props.modules.byId) {
      console.log('[PYPPartContainer] Calling initializePYPPart')
      this.props.initializePYPPart(this.props.match, this.props.history)
        .catch((error) => {
          console.error('[PYPPartContainer] initializePYPPart failed:', error)
        })
    } else {
      console.log('[PYPPartContainer] Conditions not met, retrying...', {
        pypIsInitialized: this.props.pypIsInitialized,
        hasModules: !!(this.props.modules && this.props.modules.byId)
      })
      // If PYP or modules aren't ready yet, wait a bit and retry (with max retries)
      let retries = 0
      const maxRetries = 50 // 5 seconds max wait
      const checkAndRetry = () => {
        retries++
        if (this.props.pypIsInitialized && this.props.modules && this.props.modules.byId) {
          console.log('[PYPPartContainer] Conditions met after', retries, 'retries, calling initializePYPPart')
          this.props.initializePYPPart(this.props.match, this.props.history)
            .catch((error) => {
              console.error('[PYPPartContainer] initializePYPPart failed:', error)
            })
        } else if (retries < maxRetries) {
          setTimeout(checkAndRetry, 100)
        } else {
          console.error('[PYPPartContainer] Failed to meet conditions after', maxRetries, 'retries')
        }
      }
      setTimeout(checkAndRetry, 100)
    }
  }
  
  componentDidUpdate(prevProps) {
    // If PYP just finished initializing, try to initialize the part now
    if (!prevProps.pypIsInitialized && this.props.pypIsInitialized && !this.props.initializedPart) {
      console.log('[PYPPartContainer] PYP just initialized in componentDidUpdate')
      this.initializePartIfReady()
    }
    
    // If modules just became available, try to initialize the part now
    if (
      (!prevProps.modules || !prevProps.modules.byId) &&
      this.props.modules &&
      this.props.modules.byId &&
      !this.props.initializedPart &&
      this.props.pypIsInitialized
    ) {
      console.log('[PYPPartContainer] Modules just became available in componentDidUpdate')
      this.initializePartIfReady()
    }
    
    // If module changed or wasn't initialized before, initialize now
    if (
      (prevProps.currentModuleId !== this.props.currentModuleId || 
       prevProps.currentModuleTitle !== this.props.currentModuleTitle) &&
      !this.props.initializedPart &&
      this.props.pypIsInitialized &&
      this.props.modules &&
      this.props.modules.byId
    ) {
      console.log('[PYPPartContainer] Module changed in componentDidUpdate', {
        prevModuleId: prevProps.currentModuleId,
        currentModuleId: this.props.currentModuleId
      })
      this.props.initializePYPPart(this.props.match, this.props.history)
        .catch((error) => {
          console.error('[PYPPartContainer] initializePYPPart failed:', error)
        })
    }
    
    if (prevProps.currentPartTitle !== this.props.currentPartTitle) {
      document.title = `${this.props.currentPartTitle} | ${this.props.currentModuleTitle} | Pursue Your Purpose`
      gtmClickHandler({
        name: "pageViewChangeEvent",
        data: {
          page_path: `${
            this.props.location.pathname + this.props.location.search
          }`,
          page_title: document.title
        }
      })
    }
  }

  footerShouldHaveDarkBackgroundColor() {
    if (!this.props.parts || !this.props.parts.byId || !this.props.currentPartId || this.props.currentPartId === -1) {
      return false
    }
    const currentPart = this.props.parts.byId[this.props.currentPartId]
    if (!currentPart || !currentPart.name) {
      return false
    }
    // kind of a hack, might need a more robust implementation down the road
    return (
      currentPart.name.includes("Video") ||
      currentPart.name.includes("Ideal Work Day Roadmapper Reflection")
    )
  }

  getTheme() {
    if (!this.props.parts || !this.props.parts.byId || !this.props.currentPartId || this.props.currentPartId === -1) {
      return "dark"
    }
    const currentPart = this.props.parts.byId[this.props.currentPartId]
    if (!currentPart || !currentPart.name) {
      return "dark"
    }
    return this.lightThemePartNames.includes(currentPart.name)
      ? "light"
      : "dark"
  }

  isCourseBuilderDarkPage() {
    const currentPart = this.props.parts?.byId?.[this.props.currentPartId]
    if (!currentPart) return false

    if (currentPart.elements?.length && this.props.elements?.byId) {
      const hasVideo = currentPart.elements.some(
        (id) => this.props.elements.byId[id]?.name === "Video"
      )
      if (hasVideo) return true
    }

    return this.footerShouldHaveDarkBackgroundColor()
  }

  getBackArrowFill() {
    if (isCourseBuilderWorkshop(this.props.pyp)) {
      return this.isCourseBuilderDarkPage() ? "#fff" : colors.mediumBlue
    }
    return this.getTheme() === "light" ? colors.mediumBlue : "#fff"
  }

  getLogoFill() {
    if (isCourseBuilderWorkshop(this.props.pyp)) {
      return this.isCourseBuilderDarkPage() ? colors.white : colors.midnight
    }
    return this.getTheme() === "light" ? colors.midnight : colors.white
  }

  clickChatIcon() {
    this.props.toggleModal({
      modal_mode: true,
      modal_usi: "coachesNotes"
    })
  }

  render() {
    console.log('[PYPPartContainer] render', {
      initializedPart: this.props.initializedPart,
      currentPartId: this.props.currentPartId,
      hasParts: !!(this.props.parts && this.props.parts.byId),
      partsCount: this.props.parts?.allIds?.length || 0,
      pypIsInitialized: this.props.pypIsInitialized
    })

    if (!this.props.initializedPart) {
      console.log('[PYPPartContainer] Rendering loader - part not initialized')
      return (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Loader
            type="Oval"
            color={colors.midnight}
            height="100"
            width="100"
          />
        </div>
      )
    }

    const partsCount = this.props.parts?.allIds?.length || 0
    if (partsCount === 0) {
      return (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "24px",
            padding: "24px",
            textAlign: "center",
            backgroundColor: colors.background
          }}
        >
          <p style={{ color: colors.midnight, fontSize: "18px", margin: 0 }}>
            This module has no content yet.
          </p>
          <CommitButtonWithoutClickState
            clickHandler={() => this.props.exitModule(this.props.history)}
            id="pyp-empty-module-back"
            type="mediumBlue"
            style={{ width: "auto", minWidth: "200px" }}
          >
            Back to module
          </CommitButtonWithoutClickState>
        </div>
      )
    }
    
    // Safety checks: Ensure parts data is loaded
    if (!this.props.parts || !this.props.parts.byId || !this.props.currentPartId || this.props.currentPartId === -1) {
      return (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Loader
            type="Oval"
            color={colors.midnight}
            height="100"
            width="100"
          />
        </div>
      )
    }
    
    const currentPart = this.props.parts.byId[this.props.currentPartId]
    
    // Safety check: Ensure currentPart exists
    if (!currentPart) {
      return (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Loader
            type="Oval"
            color={colors.midnight}
            height="100"
            width="100"
          />
        </div>
      )
    }
    
    // Safety check: Ensure elements exist
    const currentElements = currentPart.elements || []
    if (!this.props.elements || !this.props.elements.byId) {
      return (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Loader
            type="Oval"
            color={colors.midnight}
            height="100"
            width="100"
          />
        </div>
      )
    }
    
    const elementString = currentElements
      .map((e) => {
        const element = this.props.elements.byId[e]
        return element ? element.name : ''
      })
      .filter(name => name !== '')
      .sort()
      .toString()
    const PageComponent =
      PYPPartComponentMap[elementString] || PYPPartComponentMap.default
    return (
      <>
        <div
          id="PYP_container"
          style={{
            ...styles.componentContainer,
            backgroundColor:
              this.getTheme() === "light" ? colors.background : colors.midnight
          }}
        >
          <CoachesNotesModal />
          <MediaQuery minWidth={600}>
            <div style={styles.hamburgerContainer}>
              <BackArrow
                onClick={() => {
                  gtmClickHandler({
                    name: "ExitModuleBackArrowClickedEvent",
                    data: {
                      action: "Exit Module Back Arrow Clicked",
                      category: "PYP Engagement",
                      label: this.props.match.params.module
                    }
                  })
                  // todo: we only need to save if it's certain kinds. This could be the place, but maybe not?
                  this.props.savePYP()
                  this.props.exitModule(this.props.history)
                }}
                fill={this.getBackArrowFill()}
              />
              {coachesNotesParts.includes(this.props.currentPartTitle) && (
                <Tooltip
                  style={{
                    display: "flex"
                  }}
                  show={
                    !this.props.userGuides.length ||
                    !this.props.userGuides.find((guide) => {
                      return guide.unique_string_identifier === "COACHES_NOTES"
                    })
                  }
                  width={290}
                  height={50}
                  modalHorizontalOffset={-80}
                  arrowOffset={-45}
                  orientation="left"
                  toggleModal={() => {
                    // Called when user clicks outside of Tooltip modal
                    // removePartCompletionErrors()
                  }}
                  contentComponent={(props) => {
                    // The modal body
                    return (
                      <div
                        style={{
                          color: colors.mediumBlue,
                          fontSize: "16px",
                          lineHeight: "22px",
                          fontFamily: "Lato-Regular",
                          width: "270px"
                        }}
                      >
                        {/* This is specific to the only part currently using coaches notes. If you need to generalize, a hash map using a part name could work. */}
                        <p>
                          Click the Coach's notes icon for help thinking through
                          your ideal day.
                        </p>

                        <CommitButtonWithoutClickState
                          clickHandler={() => {
                            this.props.completeGuide("COACHES_NOTES")
                          }}
                          id="return to module"
                          type="red"
                          style={{
                            width: "150px",
                            marginTop: "20px"
                          }}
                        >
                          Got it!
                        </CommitButtonWithoutClickState>
                      </div>
                    )
                  }}
                  renderComponent={(props) => {
                    return (
                      <ChatIcon
                        style={{
                          color: colors.fadedRed,
                          marginRight: "20px",
                          cursor: "pointer"
                        }}
                        onClick={this.clickChatIcon}
                      />
                    )
                  }}
                />
              )}
            </div>
          </MediaQuery>
          <MediaQuery maxWidth={599}>
            <div
              style={{
                ...styles.mobileHamburgerContainer,
                backgroundColor:
                  this.getTheme() === "light"
                    ? colors.background
                    : colors.midnight
              }}
            >
              <BackArrow
                style={{
                  marginLeft: "20px"
                }}
                onClick={() => {
                  // TODO: we only need to save if it's certain parts
                  this.props.savePYP()
                  this.props.exitModule(this.props.history)
                }}
                fill={this.getBackArrowFill()}
              />
              <FullCommitLogo
                fill={this.getLogoFill()}
              />
              {/* todos: calendar icon part, getting the button working with modaldialoghandler.js, clean up code, make a PR */}
              {coachesNotesParts.includes(this.props.currentPartTitle) ? (
                <ChatIcon
                  style={{
                    color: colors.fadedRed,
                    marginRight: "20px",
                    cursor: "pointer"
                  }}
                  onClick={this.clickChatIcon}
                />
              ) : (
                <div style={{ width: "28px", marginRight: "20px" }} />
              )}
            </div>
          </MediaQuery>
          <PageComponent key={this.props.currentPartId} />
        </div>
        <PYPFooter
          style={{
            ...styles.footerContent,
            boxShadow:
              this.getTheme() === "light" &&
              "0 -20px 53px 0 rgba(0, 0, 0, 0.04)",
            backgroundColor:
              this.getTheme() === "light"
                ? colors.background
                : this.footerShouldHaveDarkBackgroundColor() && colors.midnight
          }}
          desktopComponent={
            <PYPPartDesktopFooterContent
              style={{
                ...styles.desktopFooter
              }}
            />
          }
          mobileComponent={<PYPPartMobileFooterContent />}
        />
      </>
    )
  }
}

const styles = {
  desktopFooter: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center"
  },
  componentContainer: {
    width: "100%",
    minHeight: "100vh",
    color: "white"
  },
  footerContent: {
    display: "flex",
    zIndex: 2,
    alignItems: "center",
    width: "100%"
  },
  hamburgerContainer: {
    position: "absolute",
    paddingLeft: "50px",
    paddingTop: "20px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  mobileHamburgerContainer: {
    position: "absolute",
    paddingTop: "20px",
    paddingBottom: "20px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    parts: state.pyp.parts,
    currentPartId: state.pyp.navigation.currentPartId,
    currentPartTitle:
      state.pyp.parts &&
      state.pyp.navigation.currentPartId > -1 &&
      state.pyp.parts.byId[state.pyp.navigation.currentPartId] &&
      state.pyp.parts.byId[state.pyp.navigation.currentPartId].name,
    currentModuleId: state.pyp.navigation.currentModuleId,
    currentModuleTitle:
      state.pyp.modules &&
      state.pyp.modules.byId &&
      state.pyp.modules.byId[state.pyp.navigation.currentModuleId] &&
      state.pyp.modules.byId[state.pyp.navigation.currentModuleId].title,
    elements: state.pyp.elements,
    modules: state.pyp.modules,
    unlockedUserModules: state.pyp.unlockedUserModules,
    initializedPart: state.pyp.initializedPart,
    pypIsInitialized: state.pyp.initialized,
    pyp: state.pyp,
    userGuides: state.user.user.guides
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PYPPartContainer)
)
